import { FormFeedBack, ModalBase } from '@repo/ui';
import { ApiKeysServiceInterface } from 'domain/services';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Col, Form, Input, Label, Row } from 'reactstrap';
import * as Yup from 'yup';

import { ApiKey } from '../../models';

interface IProps {
  isOpen: boolean;
  apiKey: ApiKey | null;
  apiKeysService: ApiKeysServiceInterface;
  toggleModal: () => void;
  onUpdated: () => void;
}

export const ModalEditApiKey = ({
  isOpen,
  apiKey,
  apiKeysService,
  toggleModal,
  onUpdated,
}: IProps) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      appName: apiKey?.appName ?? '',
    },
    validationSchema: Yup.object({
      appName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: async (values, helpers) => {
      if (!apiKey) return;
      setLoading(true);
      try {
        await apiKeysService.updateApiKeyName({
          id: apiKey.id,
          appName: values.appName,
        });
        helpers.resetForm();
        toggleModal();
        onUpdated();
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (!isOpen) formik.resetForm();
  }, [isOpen]);

  return (
    <ModalBase.Wrapper
      size="sm"
      isOpen={isOpen}
      loading={loading}
      toggle={toggleModal}
      onClosed={formik.resetForm}
    >
      <ModalBase.Header toggle={toggleModal} withBorderBottom>
        Editar chave de API
      </ModalBase.Header>

      <Form autoComplete="off" onSubmit={formik.handleSubmit}>
        <ModalBase.Body>
          <Row>
            <Col md={12}>
              <Label htmlFor="editApiKeyAppName" className="form-label">
                Nome
              </Label>
              <Input
                id="editApiKeyAppName"
                type="text"
                name="appName"
                autoFocus
                className="form-control"
                value={formik.values.appName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.appName && !!formik.errors.appName}
              />
              <FormFeedBack
                error={formik.errors.appName}
                isInvalid={formik.touched.appName && !!formik.errors.appName}
              />
            </Col>
          </Row>
        </ModalBase.Body>

        <ModalBase.Footer>
          <ModalBase.Actions
            loading={loading}
            goBack={toggleModal}
            actionBtnType="submit"
            confirmBtnLabel="Salvar"
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
